import { render } from "./customers-details.vue?vue&type=template&id=1e099d1d&scoped=true"
import script from "./customers-details.vue?vue&type=script&lang=js"
export * from "./customers-details.vue?vue&type=script&lang=js"

import "./customers-details.vue?vue&type=style&index=0&id=1e099d1d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e099d1d"]])

export default __exports__